export default "__VITE_ASSET__C3Y467Bt__"